import { render, staticRenderFns } from "./Error-5.vue?vue&type=template&id=10a4f459"
import script from "./Error-5.vue?vue&type=script&lang=js"
export * from "./Error-5.vue?vue&type=script&lang=js"
import style0 from "./Error-5.vue?vue&type=style&index=0&id=10a4f459&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports